export const IN_PROGRESS="IN PROGRESS";
export const COMPLETED="COMPLETED";
export const FAILED="FAILED";
export const CLOSED="CLOSED";
export const CHECKOUT="CHECKOUT";